var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    zoomAndPan: "magnify",
    viewBox: "0 0 52.5 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0ab356f297"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.765625 1.765625 L 50.054688 1.765625 L 50.054688 50.054688 L 1.765625 50.054688 Z M 1.765625 1.765625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ab356f297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea9301",
    d: "M 25.957031 6.164062 C 15.023438 6.164062 6.164062 15.023438 6.164062 25.957031 C 6.164062 36.886719 15.023438 45.75 25.957031 45.75 C 36.886719 45.75 45.75 36.886719 45.75 25.957031 C 45.75 15.023438 36.886719 6.164062 25.957031 6.164062 Z M 1.765625 25.957031 C 1.765625 12.59375 12.59375 1.765625 25.957031 1.765625 C 39.316406 1.765625 50.148438 12.59375 50.148438 25.957031 C 50.148438 39.316406 39.316406 50.148438 25.957031 50.148438 C 12.59375 50.148438 1.765625 39.316406 1.765625 25.957031 Z M 1.765625 25.957031 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ea9301",
    d: "M 23.757812 18.625 L 28.15625 18.625 L 28.15625 40.617188 L 23.757812 40.617188 Z M 23.757812 18.625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea9301",
    d: "M 23.757812 11.292969 L 28.15625 11.292969 L 28.15625 16.179688 L 23.757812 16.179688 Z M 23.757812 11.292969 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.1a03ed93d5130e88a851abd53a366cd0.svg";
export { ForwardRef as ReactComponent };